import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {AccountProvider} from '../../../../providers/account/account';
import {MemberProvider} from '../../../../providers/company/member/member';
import {ContaBancariaDTO} from '../../../../model/dto/ContaBancariaDTO';
import {PessoaFiscalDTO} from '../../../../model/dto/PessoaFiscalDTO';
import {HttpErrorResponse} from '@angular/common/http';
import * as moment from 'moment';
import {ExcelExportProperties, GridComponent, SelectionService} from '@syncfusion/ej2-angular-grids';
import {ClickEventArgs} from '@syncfusion/ej2-navigations';
import {ErrorUtil} from '../../../../util/error';
import {Snackbar} from '../../../../util/snackbar';
import {DateUtil} from 'src/util/dateUtil';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {ReportsProvider} from 'src/providers/reports/ReportsProvider';
import {ImovelDTO} from "../../../../model/dto/ImovelDTO";
import {PropertyProvider} from "../../../../providers/company/property/property";
import {BankAccountProvider} from "../../../../providers/company/bank_account/bank_account";
import {ReportsUtil} from "../../../../util/Reports";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {ModalExportComponent} from "../modal-export/modal-export.component";
import {MembersCharts} from "./charts";
import {ReportsHelper} from "../../../../util/ReportsHelper";
import {ConsultDateUtil} from "../../../../util/consultDateUtil";
import {Chart} from "chart.js";
import {ProcessPieChart} from "../chartProcessingUtil/process-pie-chart";
import {ProcessBarChart} from "../chartProcessingUtil/process-bar-chart";
import {ExportPdfWithChartImages} from "../chartProcessingUtil/export-pdf-with-chart-images";
import { ProdNameBuilder } from '../prod-name-builder';


@Component({
  selector: 'app-analise-participante',
  templateUrl: './analise-participante.component.html',
  styleUrls: ['./analise-participante.component.scss'],
  providers: [SelectionService,
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ]
})
export class AnaliseParticipanteComponent implements OnInit {

  @ViewChild('grid', {static: false}) public grid: GridComponent;

  consultando: boolean;
  anual = true;
  personalizado = false;

  deducao: string;

  contas: ContaBancariaDTO[];
  socios: PessoaFiscalDTO[];
  imoveis: ImovelDTO[];
  members = new FormControl();
  bankAccount = new FormControl();
  property = new FormControl();

  toolbarOptions: any[];
  dataSourceMain: Array<any> = [];
  despesaAttributes: Object;
  receitaAttributes: Object;
  public changed: boolean = false;

  public links = ['Receita', 'Despesa'];
  // @ts-ignore
  public activeLink: 'Receita' | 'Despesa' = this.links[0];
  public lastOrder = {field: '', direction: '', searching: ""};

  constructor(public accountProvider: AccountProvider,
              public errorUtil: ErrorUtil,
              public modalService: NgbModal,
              private propertyProvider: PropertyProvider,
              private bancoProvider: BankAccountProvider,
              public snackBar: Snackbar,
              private reportsProvider: ReportsProvider,
              public memberProvider: MemberProvider,
              public consultDateUtil: ConsultDateUtil,
              public charts: MembersCharts,
              public reportsUtil: ReportsUtil,
              public reportsHelper: ReportsHelper,
              private _adapter: DateAdapter<any>,
              private prodNameBuilder: ProdNameBuilder,
              private processPieChart: ProcessPieChart,
              private processBarChart: ProcessBarChart,
              private exportPdfWithChartImages: ExportPdfWithChartImages) {
  }

  ngOnInit() {
    this.initializeData();
    this.tableConfiguration();
    this.charts.start();
  }

  tableConfiguration() {
    this.toolbarOptions = [
      {text: 'Exportar', tooltipText: 'Exportar', prefixIcon: 'e-pdfexport', id: 'export'},
      'ColumnChooser'
    ];
    this._adapter.setLocale('pt-BR');
    this.despesaAttributes = {style: 'color: red;'};
    this.receitaAttributes = {style: 'color: green;'};
  }

  actionBegin(args) {
    if (args.requestType === 'filterchoicerequest') {
      args.filterChoiceCount = 1000000; //here you can change the filterchoice count as per your requirement
    }
    if (args.requestType === 'sorting') {
      this.lastOrder.field = args.columnName;
      this.lastOrder.direction = args.direction;
    }
    if (args.requestType === 'searching') {
      this.lastOrder.searching = args.searchString;
    }
  }

  initializeData() {
    this.deducao = 'TODOS';
    this.consultando = true;
    this.dataSourceMain = [];

    this.memberProvider.getAllMembers().then((members: PessoaFiscalDTO[]) => {
      this.socios = members;
      this.bancoProvider.getAllBanksAccounts().then((accounts: ContaBancariaDTO[]) => {
        this.contas = accounts;
        this.contas.push({
          id: null,
          description: 'Sem conta',
          bankId: null,
          code: null,
          countryId: null,
          agencyWithoutDV: null,
          accountNumberWithDV: null,
          bankDTORespComp: null,
          countryDTORespComp: null,
          default: false
        });
        this.propertyProvider.getAllProperty().then((properties: ImovelDTO[]) => {
          this.imoveis = properties;
          this.consultando = false;
          this.initialSelects();
        }).catch((result: HttpErrorResponse) => {
          this.errorUtil.checkErrorStatus(result, result.status, result.error, 'relatorios-livroCaixa');
          this.consultando = false;
          console.error(result);
        });
      });
    });
  }

  tabsTypeFilter() {
    this.consultando = true;
    this.dataSourceMain = [];

    let members = this.socios.map((value) => value.cpfCNPJ);
    if (this.members.value.length !== 0) {
      members = this.members.value.map((value) => value.cpfCNPJ);
    }

    let property = this.imoveis.map((value) => value.propertyCode);
    if (this.property.value.length !== 0) {
      property = this.property.value.map((value) => value.propertyCode);
    }

    let account = this.contas.map((value) => value.id);
    if (this.bankAccount.value.length !== 0) {
      account = this.bankAccount.value.map((value) => value.id);
    }

    let data: any = {};
    if (this.personalizado) {
      this.consultDateUtil.monthly = false;
      data = this.consultDateUtil.getDateForRequest(false);
    } else if (this.anual) {
      data.startDate = this.consultDateUtil.year + '-01-01';
      data.endDate = this.consultDateUtil.year + '-12-31';
    } else {
      this.consultDateUtil.monthly = true;
      data = this.consultDateUtil.getDateForRequest(false);
    }

    let realeseType = 0;
    if (this.deducao == 'DEDUTIVEIS') {
      realeseType = 1;
    } else if (this.deducao == 'NAODEDUTIVEIS') {
      realeseType = 2;
    }

    let params = {
      cpfCnpjs: members,
      postingReleaseType: realeseType,
      propertyCodes: property,
      bankAccountIds: account
    }

    this.generateReport(params, data.startDate, data.endDate);
  }

  generateReport(params, initalDate, finalDate) {
    this.reportsProvider.getReportMembers(initalDate, finalDate, params)
      .then((result: any) => {
        this.consultando = false;
        this.dataSourceMain = result;
        this.changed = false;
        this.charts.aux = result;
        this.charts.generate();
      }).catch((result: HttpErrorResponse) => {
      this.errorUtil.checkErrorStatus(result, result.status, result.error, 'relatorios-analiseParticipant');
      this.changed = false;
      this.consultando = false;
      console.error(result);
    });
  }

  updateChanged() {
    this.changed = true;
  }

  limpaMembers(bool) {
    if (bool) {
      this.members.setValue(this.socios);
    } else {
      this.members.setValue([])
    }
  }

  limpaImoveis(bool) {
    if (bool) {
      this.property.setValue(this.imoveis)
    } else {
      this.property.setValue([])
    }
  }

  limpaConta(bool) {
    if (bool) {
      this.bankAccount.setValue(this.contas)
    } else {
      this.bankAccount.setValue([])
    }
  }

  initialSelects() {
    this.members.setValue([])
    this.property.setValue([])
    this.bankAccount.setValue([])
  }

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'export') {
      let modalOptions: NgbModalOptions = {
        backdrop: 'static',
        windowClass: localStorage.getItem('theme') == 'dark'? 'dark-theme' : '',
      };
      const modalRef = this.modalService.open(ModalExportComponent, modalOptions);
      modalRef.componentInstance.texto = "as despesas ou receitas de cada participante";
      modalRef.componentInstance.relatorio = 'analise-participante';
      modalRef.result.then((result: any) => {
        if (result.type === 'pdf') {
          this.exportPDF(result.img);
        } else if (result.type === 'excel') {
          this.exportExcel();
        }
      });
    }
  }

  exportPDF(img){
    const date = moment().format('DD/MM/YY HH:mm').toString();

    let deducao: string;
    if (this.deducao === 'TODOS')
      deducao = 'Todos os valores';
    else if (this.deducao === 'DEDUTIVEIS')
      deducao = 'Dedutíveis';
    else
      deducao = 'Não dedutíveis';

    let properties = 'Todos os imóveis';
    if (this.property.value != null) {
      if (!(this.property.value.length == this.imoveis.length || this.property.value.length == 0)) {
        let tmp = [];
        this.property.value.forEach((value) => {
          tmp.push(value.propertyCode);
        });
        properties = (tmp.length > 1) ? tmp.join(', ') : tmp[0];
      }
    }

    let accounts = 'Todas as contas';
    if (this.bankAccount.value != null) {
      if (!(this.bankAccount.value.length == this.contas.length || this.bankAccount.value.length == 0)) {
        let tmp = [];
        this.bankAccount.value.forEach((value) => {
          tmp.push(value.description);
        });
        accounts = (tmp.length > 1) ? tmp.join(', ') : tmp[0];
      }
    }

    let members = 'Todos os produtores';
    if (this.members.value != null) {
      if (!((this.members.value.length == this.socios.length && this.members.value.length != 1) || this.members.value.length == 0)) {
        let tmp = [];
        this.members.value.forEach((value) => {
          tmp.push({name :value.name, cpfCNPJ: value.cpfCNPJ});
        });
        members = this.prodNameBuilder.build(tmp);
      }
    }

    let period;
    if (this.anual)
      period = this.consultDateUtil.year;
    else if (this.personalizado)
      period = moment(this.consultDateUtil.startDate).format('DD/MM/YY') + ' - ' + moment(this.consultDateUtil.endDate).format('DD/MM/YY');
    else
      period = this.consultDateUtil.month + ' - ' + this.consultDateUtil.year;

    // @ts-ignore
    let font = this.reportsHelper.getFont((this.grid.getFilteredRecords().length > 0 ? this.grid.getFilteredRecords() : this.dataSourceMain), this.lastOrder);

    let tmp = [];
    font.forEach((value: any) => {
      tmp.push({
        name: value.name,
        cpfCnpj: value.cpfCnpj,
        incoming: Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value.incoming),
        outlay: Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value.outlay),
        balance: Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value.balance),
      });
    });

    let colunas = [
      {dataKey: 'incoming', minCellWidth: 2.5, halign: 'center'},
      {dataKey: 'outlay',   minCellWidth: 2.5, halign: 'center'},
      {dataKey: 'balance',  minCellWidth: 2.5, halign: 'center'},
    ];

    let headers = this.reportsHelper.getHeaderFromGrid(this.grid);
    this.reportsUtil.exportPDF({
      doc: {
        arquivo: `Analise participante - ${period}`,
        orientacao: 'Landscape',
      },
      cabecalho: {
        titulo: `Análise por Participante`,
        data: date,
        periodo: period,
        parametros: {
          "Dedução": deducao,
          "Imóveis": properties,
          "Produtores": members,
          "Contas": accounts,
        },
        image: img,
      },
      tabela: {
        dados: tmp,
        colunas: headers,
        estiloColunas: colunas,
      },
    });
  }

  exportExcel(){
    const exportProperties: ExcelExportProperties = {
      includeHiddenColumn: true,
      fileName: 'analiseparticipante' + this.consultDateUtil.year + '.xlsx',
    };

    for (const cols of this.grid.columns) {
      if ((cols as any).field === 'name') {
        (cols as any).width = 150;
      }
      if ((cols as any).field === 'cpfCnpj') {
        (cols as any).width = 100;
      }
      if ((cols as any).field === 'incoming') {
        (cols as any).width = 130;
        (cols as any).format = null;
      }
      if ((cols as any).field === 'outlay') {
        (cols as any).width = 130;
        (cols as any).format = null;
      }
      if ((cols as any).field === 'balance') {
        (cols as any).width = 130;
        (cols as any).format = null;
      }
      if ((cols as any).field === 'type') {
        (cols as any).visible = false;
      }
    }

    this.grid.excelExport(exportProperties);
  }

  queryCell(args) {
    if (args.column.field === 'balance' ) {
      // tslint:disable-next-line: no-string-literal
      if (args.data.balance < 0) {
        args.cell.setAttribute('style', 'color: red');
      } else {
        args.cell.setAttribute('style', 'color: green');
      }
    }
    if (args.column.field === 'incoming') {
      if (args.data.incoming != 0) {
        args.cell.setAttribute('style', 'color: green');
      }
    }

    if (args.column.field === 'outlay') {
      if (args.data.outlay != 0) {
        args.cell.setAttribute('style', 'color: red');
      }
    }
  }

  excelQueryCellInfo(args: any): void {
    let textColor = '#000000';
    if (args.column.field == 'incoming') {
      if (args.value != 0) {
        textColor = '#27c24c';
      }
    }
    if (args.column.field == 'outlay') {
      if (args.value != 0) {
        textColor = '#f05050';
      }
    }
    if (args.column.field === 'balance') {
      if (args.value >= 0) {
        textColor = '#27c24c';
      } else if (args.value < 0) {
        textColor = '#f05050';
      }
    }
    args.style = {textBrushColor: textColor};
  }

  tabs(link: 'Receita' | 'Despesa') {
    this.charts.changeTab(link);
  }

  exportChartImagesAsPdf(logoPresent: boolean): void {
    let div0 = document.getElementById('divChart0');
    let div1 = document.getElementById('divChart1');
    this.charts.loading = true;
    div0.style.display = 'none';
    div1.style.display = 'none';

    Chart.helpers.each(Chart.instances, (instance: any) => {
      if (instance.chart.canvas.id === 'myChart0'
        && instance.chart.width !== 800
        && instance.chart.width !== 497
      ) {
          let printFont = this.initPieChartData(instance);
          let originalFont = instance.chart.data.labels;
          this.processPieChart.process(instance.chart, printFont, originalFont, instance.chart.canvas.id);
        }
        if (instance.chart.canvas.id === "myChart1"
          && instance.chart.width !== 800
          && instance.chart.width !== 497
        ) {
          this.processBarChart.process(instance.chart, this.activeLink);
        }
      }
    );

    let period;

    if (this.anual)
      period = this.consultDateUtil.year;
    else if (this.personalizado)
      period = moment(this.consultDateUtil.startDate).format('DD/MM/YY') + ' - ' + moment(this.consultDateUtil.endDate).format('DD/MM/YY');
    else
      period = this.consultDateUtil.month + ' - ' + this.consultDateUtil.year;

    const empresa = localStorage.getItem('empresa');

    setTimeout(()=> {
      this.exportPdfWithChartImages.exportBarAndPie(`Gráficos - Análise por Participante - ${this.activeLink}`, `analise_participante_${empresa.toLowerCase().replace(' ','_')}_${period}_${this.activeLink.toLowerCase()}`, period, logoPresent)
    }, 600);

    setTimeout(() => {
      div0.style.display = '';
      div1.style.display = '';
      this.charts.loading = false;
    }, 1100);
  }

  initPieChartData(instance: any): any {
    let outrosPresent: boolean = false;
    const formatBrl = (value: number) => Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);

    //@ts-ignore
    const font = this.reportsHelper.getFont((this.grid.getFilteredRecords().length > 0 ? this.grid.getFilteredRecords() : this.dataSourceMain), this.lastOrder);
    let printFont = instance.chart.data.labels.map((label: string) => {
      if (label === "OUTROS") {
        outrosPresent = true;
      }
      const f = font.find(f => f.name === label);
      if (f) {
        if (this.activeLink === "Despesa") {
          return [label, this.addMinus(`${formatBrl(f.outlay)}`)];
        } else if (this.activeLink === "Receita") {
          return [label, `${formatBrl(f.incoming)}`];
        }
      }
      return label;
    });

    if (instance.chart.data.labels.length === 10 && outrosPresent) {
      let element = printFont.find((element: string) => element === "OUTROS");
      if (element) {
        if (this.activeLink === "Despesa") {
          element = [element, this.addMinusOutros(`${formatBrl(this.charts.doubleChartData.bar[9])}`)];
        } else if (this.activeLink === "Receita") {
          element = [element, `${formatBrl(this.charts.doubleChartData.bar[9])}`];
        }
      }
      printFont.splice(9);
      printFont.push(element);
    }

    return printFont;
  }

  addMinusOutros(outlay: string ) : string{
    return '' + outlay.substring(0, 3) + "-" + outlay.substring(3);
  }

  addMinus(outlay: string ) : string{
    return outlay.substring(0, 3) + "-" + outlay.substring(3);
  }
}
